var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"locations-list"}},[(_vm.locations && _vm.locations.items && _vm.locations.items.length === 0)?_c('div',{staticClass:"tooltip-holder"},[_vm._m(0)]):_vm._e(),_c('tc-table',{attrs:{"dataList":_vm.locations,"tbody":_vm.tbody,"settings":{
        externalFilters: {
          show: false
        },
        filters: {
          archived: {
            type: 'v-select',
            class: 'min-w-48',
            label: '',
            clearable: false,
            value: 'Active Locations',
            options: {
              text: 'name',
              value: 'id',
              items: [{
                id: 'false',
                name: 'Active Locations'
              }, {
                id: 'true',
                name: 'Archived Locations'
              }]
            }
          },
          q: {
            type: 'input',
            class: 'min-w-48',
            label: 'Search'
          },
        }
      }},on:{"filter":_vm.filter}},[_c('template',{slot:"thead"},[_c('vs-th',{attrs:{"sort-key":"name"}},[_vm._v("Site Title")]),_c('vs-th',{attrs:{"sort-key":"category"}},[_vm._v("Site Code")]),_c('vs-th',[_vm._v("Actions")])],1)],2),(_vm.$hasPermission('edit:locations'))?_c('vs-button',{staticClass:"ml-auto mt-4",attrs:{"icon-pack":"feather","icon":"icon-plus","icon-before":""},on:{"click":function($event){return _vm.$router.push('add-location')}}},[_vm._v("Add New Location")]):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tooltip tooltip--full tooltip--none"},[_c('p',[_vm._v("No Locations Found")])])}]

export { render, staticRenderFns }